<template>
  <div class="misc-wrapper">
    <b-link
      to="/"
      class="brand-logo mb-2"
    >
      <logo width="80%" />
    </b-link>

    <div class="p-2 p-sm-3 mt-sm-3">
      <div class="w-100 text-center">
        <b-overlay
          :show="loader.general"
          opacity="0.50"
          rounded="sm"
        >
          <b-row
            v-show="showContent"
            align-v="center"
          >
            <!-- Roles col -->
            <b-col
              cols="12"
              sm="12"
              md="6"
              xl="6"
            >
              <!-- Everything is good, so I will show content -->
              <div v-if="!errorPage">
                <b-alert
                  v-height-fade.appear
                  variant="primary"
                  :show="showWelcome"
                >
                  <h4 class="alert-heading">
                    Bienvenid@
                  </h4>
                  <div class="alert-body">
                    Es un gusto tenerte de vuelta <b>{{ fullName }}</b>
                  </div>
                </b-alert>
                <b-overlay
                  :show="loader.roles"
                  opacity="0.50"
                  rounded="sm"
                >
                  <b-card>
                    <h2 class="mb-1">
                      Roles disponibles 🔐
                    </h2>
                    <p class="mb-2">
                      Por favor seleccione el rol con el que desea continuar:
                    </p>

                    <b-button
                      v-for="rol in rolesDisponibles"
                      :key="rol.id"
                      :variant="(rolSelected && rolSelected.id == rol.id || rolesDisponibles.length === 1) ? 'primary' : 'light'"
                      class="mb-75"
                      block
                      @click="rolSelected = rol"
                    >
                      {{ rol.nombre }}
                    </b-button>

                  </b-card>
                </b-overlay>

                <b-button
                  v-if="rolSelected"
                  variant="primary"
                  class="mb-1 btn-sm-block"
                  @click="activarPreferencias(rolSelected)"
                >
                  Continuar como {{ (rolSelected) ? rolSelected.nombre : '' }}
                </b-button>
              </div>
              <!-- If there's an error page -->
              <div v-else>
                <b-alert
                  show
                  variant="danger"
                  class="mb-0"
                >
                  <h4 class="alert-heading">
                    Algo ha ocurrido
                  </h4>
                  <div class="alert-body">
                    <span>
                      Por favor, <b>verifique que su conexión a internet sea estable y su sesión no haya expirado</b>. Por el momento, <b>intente iniciar sesión nuevamente</b>, si el error continúa pónganse en contacto con nosotros.
                    </span>
                  </div>
                </b-alert>
                <b-button
                  variant="primary"
                  class="mt-1 mb-1 mr-75 btn-sm-block"
                  @click="closeSession()"
                >
                  <feather-icon
                    icon="HomeIcon"
                    class="mr-50"
                  />
                  Volver al inicio
                </b-button>
                <b-button
                  variant="secondary"
                  class="mt-1 mb-1 btn-sm-block"
                  @click="closeSession(true)"
                >
                  <feather-icon
                    icon="LogInIcon"
                    class="mr-50"
                  />
                  Iniciar sesión
                </b-button>
              </div>
            </b-col>

            <!-- Image col -->
            <b-col
              cols="12"
              sm="12"
              md="6"
              xl="6"
            >
              <b-img
                fluid
                :src="imgUrl"
                alt="Imagen de seleccion de rol"
              />
            </b-col>
          </b-row>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink,
  BImg,
  BButton,
  BCard,
  BRow,
  BCol,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { heightFade } from '@core/directives/animations'
import { $themeConfig } from '@themeConfig'
import {
  computed, watch, ref, onMounted,
} from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { login } from '@/auth/utils'
import { closeAccount } from '@core/mixins/account-data/account'
import { rolesActions } from '@core/mixins/account-data/roles'
import useRoles from './useRoles'

export default {
  components: {
    BLink,
    BImg,
    BButton,
    BCard,
    BRow,
    BCol,
    BAlert,
    BOverlay,
    Logo,
  },
  directives: {
    'height-fade': heightFade,
  },
  mixins: [closeAccount, rolesActions],
  setup() {
    const { appName } = $themeConfig.app //* App Name
    const { route } = useRouter() //* Use router propieties router
    const { token } = route.value.params //* Get the token from params
    const { setConfig, loadRoles, updateCurrentRole } = useRoles() //* Methods to load roles updateCurrentRole
    const { loadUserData } = login() //* Methods to load user data
    const toast = useToast()
    const loader = ref({ general: false, roles: false })
    const showContent = ref(false)
    const showWelcome = ref(false)
    const errorPage = ref(false)
    const rolSelected = ref(null)
    const downImg = ref(require('@/assets/images/pages/not-authorized.svg'))

    const configRol = ref({
      action: 5, id_rol: null, name_rol: null,
    })

    //* Computed propieties
    const fullName = computed(() => store.getters['cuenta/getFullName'])
    const shallShowOverlay = computed(() => store.state.app.shallShowOverlay)
    const imgUrl = computed(() => {
      if (store.state.appConfig.layout.skin === 'dark') {
        downImg.value = require('@/assets/images/pages/not-authorized-dark.svg')
        return downImg.value
      }
      return downImg.value
    })

    // guarda el perfil que usara en uac para uso de los demas servicios
    const activarPreferencias = inrol => {
      rolSelected.value = inrol
      loader.value.roles = true
      configRol.value.id_rol = inrol.id
      configRol.value.name_rol = inrol.nombre
      setConfig(configRol.value)
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: `Te damos la bienvenida ${fullName.value}!`,
              text: response,
              icon: 'UnlockIcon',
              variant: 'primary',
            },
          }, { timeout: 2000, position: 'top-center' })
          loader.value.roles = false
          updateCurrentRole(inrol)
          // currentRole(inrol)
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atencion [Preferencias no firmadas]',
              text: error,
              icon: 'LockIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
          loader.value.roles = false
        })
    }

    //* Load user's rol
    const fetchRoles = () => {
      loader.value.roles = true // Start roles loader - change ref value (loader.roles)
      loadRoles()
        .then(response => {
          if (response.redirectTo) {
            // tiene un solo rol y se debe firmar en uac
            activarPreferencias(response.rol)
            // router.push(response.redirectTo)
          }

          loader.value.roles = false // Stop roles loader - change ref value (loader.roles)
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [Roles de usuario]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
          loader.value.roles = false // Stop roles loader - change ref value (loader.roles)
        })
    }

    //* Load users data
    const fetchUserData = tkn => {
      loader.value.general = true //* Start general loader - change ref value (loader.general)
      loadUserData(tkn)
        .then(() => {
          showContent.value = true //* Show content div
          showWelcome.value = true //* Show welcome alert
          loader.value.general = false //* Stop general loader - change ref value (loader.general)
          fetchRoles()
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [Datos de usuario]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
          showContent.value = true //* Show content div
          loader.value.general = false //* Stop general loader - change ref value (loader.general)
          errorPage.value = true //* Show error in page
        })
    }

    //* On mounted fetch user's data
    onMounted(() => { fetchUserData(token) })

    watch(
      shallShowOverlay, status => { //* Watching the overlay from app state, so we put general loader on
        loader.value.general = status
      },
    )

    return {
      appName,
      loader,
      showContent,
      showWelcome,
      errorPage,
      rolSelected,
      fullName,
      imgUrl,
      activarPreferencias,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
